import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@bookips/sds";
export const WaitingSpinner = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "fixed top-0 left-0 flex items-center justify-center w-full h-full z-20 bg-gray-900/50",
        children: /*#__PURE__*/ _jsx(Spinner, {
            size: "lg",
            className: "text-white"
        })
    });
};
